import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import MapAndList from './components/MapAndList';
import ShopFilter from './components/ShopFilter';
import ShopList from './components/ShopList';
import useShops from './components/ShopList/hooks/useShops';
import useLocation from './hooks/useLocation';

interface Params {
    isOrder: boolean;
    type: 'LIST' | 'MAP';
    originalItemId?: string;
}

const ShopListActivity: ActivityComponentType<Params> = ({ params }:{params:Params}) => {
    const { isOrder, type, originalItemId } = params;
    const { t } = useTranslation('shopList');
    const { stepReplace } = useStepFlow('ShopListActivity');
    const { locationAgreed, ready } = useLocation();
    const {
        shops, isBlank, isFetching, fetchNextPage,
    } = useShops({
        locationAgreed, originalItemId, isOrder, ready,
    });
    return (
        <AppScreen>
            <Header title={isOrder ? t('header.order') : t('header.find')} />
            <TabList variant='transparent'>
                <TabItem selected={type === 'LIST'}
                    onClick={() => stepReplace({ type: 'LIST', isOrder, originalItemId })}>
                    {t('tabs.list')}
                </TabItem>
                <TabItem selected={type === 'MAP'}
                    onClick={() => stepReplace({ type: 'MAP', isOrder, originalItemId })}>
                    {t('tabs.map')}
                </TabItem>
            </TabList>
            <ShopFilter/>
            {type === 'LIST' ? (
                <ShopList isOrder={isOrder}
                    originalItemId={originalItemId}
                    shops={shops}
                    isLoading={isFetching}
                    fetchNext={fetchNextPage}
                    isBlank={isBlank} />
            ) : (
                <MapAndList originalItemId={originalItemId}
                    isOrder={isOrder}
                    shops={shops}
                    fetchNext={fetchNextPage}
                />
            )}
        </AppScreen>
    );
};

export default ShopListActivity;
